import {Injectable} from '@angular/core';
import {SETTINGS} from '../config/common.settings';
import {HttpClient} from '@angular/common/http';
import {LoadingService} from './loading.service';

@Injectable({
  providedIn: 'root',
})
export class OtherContentService {
  otherContent: any;

  constructor(private http: HttpClient) {
  }

  updateOtherContent(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/other_contents/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.otherContent = response;
            resolve(this.otherContent);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  createOtherContent(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/other_contents/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.otherContent = response;
            resolve(this.otherContent);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  findAllOtherContent(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/other_contents/get-all`).subscribe({
        next: (response: any) => {
          this.otherContent = response;
          resolve(this.otherContent);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }
}
